import React, { Component } from 'react';
import { connect } from 'react-redux';
import { update } from 'ducks/app';
import PropTypes from 'prop-types';
import moment from 'moment';

import styles from './TimeSimulator.scss';

const propTypes = {
  start: PropTypes.string,
  end: PropTypes.string,
  dispatch: PropTypes.func,
  simulatedTime: PropTypes.string,
};

class TimeSimulator extends Component {
  constructor(props) {
    super(props);

    const { simulatedTime } = props;
    if (simulatedTime) {
      moment.now = () => simulatedTime * 1000;
    }
  }

  componentWillUnmount() {
    moment.now = () => +new Date();
    this.props.dispatch(update({ simulatedTime: null }));
  }

  onChange = (event) => {
    const simulatedTime = event.target.value;

    if (this.raf) {
      window.cancelAnimationFrame(this.raf);
    }

    this.raf = window.requestAnimationFrame(() => {
      this.raf = null;

      moment.now = () => simulatedTime * 1000;
      this.props.dispatch(update({ simulatedTime }));
    });
  };

  render() {
    const {
      start,
      end,
      simulatedTime,
    } = this.props;

    return (
      <div className={styles.base}>
        Simulated time:
        {' '}
        {simulatedTime && moment(simulatedTime * 1000).format()}
        {start && end && (
          <input
            type="range"
            min={moment(start).subtract(1, 'day').unix()}
            max={moment(end).add(1, 'day').unix()}
            className={styles.slider}
            onChange={this.onChange}
            value={simulatedTime || moment(start).unix()}
          />
        )}
      </div>
    );
  }
}

TimeSimulator.propTypes = propTypes;

const mapStateToProps = (state) => ({
  simulatedTime: state.getIn(['app', 'simulatedTime']),
});

export default connect(mapStateToProps)(TimeSimulator);
